import { Box } from '@/components/Box/Box';
import { AuthLayout } from '../../ui/AuthLayout/AuthLayout';
import { AuthStep } from '../../ui/AuthStep/AuthStep';
import { useNavigate } from 'react-router';
import { getLoginPath } from '@/bundle/Auth/LoginFlow/LoginPage/path/path';
import { Button } from '@/components/Button/Button';
import ExpiredLinkIcon from '@/images/ExpiredLinkIcon.svg?react';
import { AuthTitle } from '../../ui/AuthTitle/AuthTitle';

export const LinkExpiredPage = () => {
  const navigate = useNavigate();

  const redirectToLogin = () => {
    return navigate(getLoginPath());
  };

  return (
    <AuthLayout>
      <AuthStep>
        <Box alignItems='center' flexDirection='column'>
          <Box marginBottom='28px'>
            <ExpiredLinkIcon />
          </Box>
          <AuthTitle marginBottom={36}>The link has been expired</AuthTitle>

          <Button onClick={redirectToLogin}>Return to Login</Button>
        </Box>
      </AuthStep>
    </AuthLayout>
  );
};
